import { _ as _applyDecoratedDescriptor } from '../../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("{{!-- One NvTabs tab (panel variant). The label\'s 600 width is reserved by the strip modifier (data-text + ::after, _tabs.scss). --}}\n<button\n  type=\'button\'\n  role=\'tab\'\n  id={{this.domId}}\n  class=\'nv-tablist-tab {{if @selected \"is-selected\"}}\'\n  aria-selected={{if @selected \'true\' \'false\'}}\n  aria-controls={{@controls}}\n  aria-disabled={{if @disabled \'true\'}}\n  aria-busy={{if @busy \'true\'}}\n  tabindex={{if @selected \'0\' \'-1\'}}\n  data-ui-part=\'tab\'\n  ...attributes\n  {{nv-disabled-reason this.reason}}\n  {{on \'click\' this.activate}}\n>\n  {{#if @icon}}\n    <FaIcon @icon={{@icon}} class=\'nv-tablist-icon\' aria-hidden=\'true\' />\n  {{/if}}\n  <span class=\'nv-tablist-label\'><span class=\'nv-tablist-text\'>{{yield}}</span></span>\n  {{#if this.hasCount}}\n    <span class=\'nv-tablist-count\' aria-hidden={{if @countLabel \'true\'}} {{nv-flash-on-change @count}}>{{@count}}</span>\n    {{#if @countLabel}}\n      <span class=\'nv-sr-only\'>{{@countLabel}}</span>\n    {{/if}}\n  {{/if}}\n</button>\n");

var _class;
let NvTabsTab = (_class = class NvTabsTab extends Component {
  get domId() {
    return this.args.id ? `nv-tab-${this.args.id}` : undefined;
  }
  get hasCount() {
    return this.args.count !== null && this.args.count !== undefined && this.args.count !== '';
  }
  get reason() {
    return this.args.disabled ? this.args.disabledReason || null : null;
  }
  activate() {
    if (this.args.disabled) return; // silent-guard-ok: aria-disabled tab, nv-disabled-reason explains on press
    // silent-guard-ok: the selected tab is already loading its panel (aria-busy + progress cursor say so)
    if (this.args.busy && this.args.selected) return;
    this.args.onSelect?.();
  }
}, _applyDecoratedDescriptor(_class.prototype, "activate", [action], Object.getOwnPropertyDescriptor(_class.prototype, "activate"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, NvTabsTab);

export { NvTabsTab as default };
//# sourceMappingURL=tab.js.map
